import * as React from "react";
import { BinDefinitionCustom } from './BinDefinitionCustom.js';
import { BinDefinitionUniform } from './BinDefinitionUniform.js';
import { BinTable } from './BinTable.js';
export function BinnedSampleCard({ data, bins, setBins, decimals }) {
    const [activeTabIndex, setActiveTabIndex] = React.useState(0);
    const labels = React.useMemo(() => ['Stejně dlouhé třídy', 'Různě dlouhé třídy'], []);
    return (React.createElement("div", { style: { textAlign: "left" }, className: "card" },
        React.createElement("p", { className: "cardTitle" }, "Rozt\u0159\u00EDd\u011Bn\u00FD soubor"),
        React.createElement("div", null,
            React.createElement(TabGroup, { labels: labels, activeTabIndex: activeTabIndex, setActiveTabIndex: setActiveTabIndex }),
            activeTabIndex === 0 ?
                React.createElement(BinDefinitionUniform, { data: data, setBins: setBins, decimals: decimals }) :
                React.createElement(BinDefinitionCustom, { data: data, setBins: setBins, decimals: decimals })),
        React.createElement(BinTable, { bins: bins, decimals: decimals })));
}
function TabGroup({ labels, activeTabIndex, setActiveTabIndex }) {
    return (React.createElement("div", { style: { display: "flex" } }, labels.map((label, index) => (React.createElement("button", { className: activeTabIndex === index ? "tab-active" : "tab-inactive", key: label, onClick: () => setActiveTabIndex(index) }, label)))));
}
//# sourceMappingURL=BinnedSampleCard.js.map